var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal = function isLocal() {
  return window.location.protocol === 'file:';
};

var svgCache = new Map();

var requestQueue = {};
var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function processRequestQueue(url) {
  var _loop = function _loop(i, len) {
    // Make these calls async so we avoid blocking the page/renderer.
    setTimeout(function () {
      /* istanbul ignore else */
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = svgCache.get(url);
        var callback = requestQueue[url][i];
        /* istanbul ignore else */

        if (cacheValue instanceof SVGSVGElement || cacheValue instanceof HTMLElement) {
          callback(null, cloneSvg(cacheValue));
        }
        /* istanbul ignore else */


        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }
        /* istanbul ignore else */


        if (i === requestQueue[url].length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };

  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    _loop(i, len);
  }
};

var loadSvg = function loadSvg(url, callback) {
  if (svgCache.has(url)) {
    var cacheValue = svgCache.get(url);

    if (cacheValue instanceof SVGSVGElement || cacheValue instanceof HTMLElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }

    if (cacheValue instanceof Error) {
      callback(cacheValue);
      return;
    }

    queueRequest(url, callback);
    return;
  } // Seed the cache to indicate we are loading this URL.


  svgCache.set(url, undefined);
  queueRequest(url, callback);
  var httpRequest = new XMLHttpRequest();

  httpRequest.onreadystatechange = function () {
    try {
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal() ? 'Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.' : 'Unable to load SVG file: ' + url);
        }

        if (httpRequest.status === 200 || isLocal() && httpRequest.status === 0) {
          /* istanbul ignore else */
          if (httpRequest.responseXML instanceof Document) {
            /* istanbul ignore else */
            if (httpRequest.responseXML.documentElement) {
              svgCache.set(url, httpRequest.responseXML.documentElement);
            }
          }

          processRequestQueue(url);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      svgCache.set(url, error);
      processRequestQueue(url);
    }
  };

  httpRequest.open('GET', url); // Treat and parse the response as XML, even if the server sends us a
  // different mimetype.

  /* istanbul ignore else */

  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('text/xml');
  }

  httpRequest.send();
};

var idCounter = 0;

var uniqueId = function uniqueId() {
  return ++idCounter;
};

var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';

var injectElement = function injectElement(el, callback, _ref) {
  var evalScripts = _ref.evalScripts,
      renumerateIRIElements = _ref.renumerateIRIElements;
  var imgUrl = el.getAttribute('data-src') || el.getAttribute('src');
  /* istanbul ignore else */

  if (!imgUrl || !/\.svg/i.test(imgUrl)) {
    callback(new Error('Attempted to inject a file with a non-svg extension: ' + imgUrl));
    return;
  } // Make sure we aren't already in the process of injecting this element to
  // avoid a race condition if multiple injections for the same element are run.
  // :NOTE: Using indexOf() only _after_ we check for SVG support and bail, so
  // no need for IE8 indexOf() polyfill.

  /* istanbul ignore else */


  if (injectedElements.indexOf(el) !== -1) {
    // TODO: Extract.
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  } // Remember the request to inject this element, in case other injection calls
  // are also trying to replace this element before we finish.


  injectedElements.push(el); // Try to avoid loading the orginal image src if possible.

  el.setAttribute('src', '');
  loadSvg(imgUrl, function (error, svg) {
    /* istanbul ignore else */
    if (!svg) {
      // TODO: Extract.
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }

    var imgId = el.getAttribute('id');
    /* istanbul ignore else */

    if (imgId) {
      svg.setAttribute('id', imgId);
    }

    var imgTitle = el.getAttribute('title');
    /* istanbul ignore else */

    if (imgTitle) {
      svg.setAttribute('title', imgTitle);
    }

    var mergedClasses = Array.from(new Set([].concat((svg.getAttribute('class') || '').split(' '), ['injected-svg'], (el.getAttribute('class') || '').split(' ')))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var imgStyle = el.getAttribute('style');
    /* istanbul ignore else */

    if (imgStyle) {
      svg.setAttribute('style', imgStyle);
    }

    svg.setAttribute('data-src', imgUrl); // Copy all the data elements to the svg.

    var imgData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(imgData, function (dataAttr) {
      /* istanbul ignore else */
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });
    /* istanbul ignore else */

    if (renumerateIRIElements) {
      // Make sure any internally referenced clipPath ids and their clip-path
      // references are unique.
      //
      // This addresses the issue of having multiple instances of the same SVG
      // on a page and only the first clipPath id is referenced.
      //
      // Browsers often shortcut the SVG Spec and don't use clipPaths contained
      // in parent elements that are hidden, so if you hide the first SVG
      // instance on the page, then all other instances lose their clipping.
      // Reference: https://bugzilla.mozilla.org/show_bug.cgi?id=376027
      // Handle all defs elements that have iri capable attributes as defined by
      // w3c: http://www.w3.org/TR/SVG/linking.html#processingIRI. Mapping IRI
      var iriElementsAndProperties = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var element;
      var elements;
      var properties;
      var currentId;
      var newId;
      Object.keys(iriElementsAndProperties).forEach(function (key) {
        element = key;
        properties = iriElementsAndProperties[key];
        elements = svg.querySelectorAll(element + '[id]');

        var _loop = function _loop(a, elementsLen) {
          currentId = elements[a].id;
          newId = currentId + '-' + uniqueId(); // All of the properties that can reference this element type.

          var referencingElements = void 0;
          Array.prototype.forEach.call(properties, function (property) {
            // :NOTE: using a substring match attr selector here to deal with IE
            // "adding extra quotes in url() attrs".
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId + '"]');

            for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
              var attrValue = referencingElements[b].getAttribute(property);

              if (attrValue && !attrValue.match(new RegExp('url\\(#' + currentId + '\\)'))) {
                continue;
              }

              referencingElements[b].setAttribute(property, 'url(#' + newId + ')');
            }
          });
          var allLinks = svg.querySelectorAll('[*|href]');
          var links = [];

          for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
            var href = allLinks[c].getAttributeNS(xlinkNamespace, 'href');
            /* istanbul ignore else */

            if (href && href.toString() === '#' + elements[a].id) {
              links.push(allLinks[c]);
            }
          }

          for (var d = 0, linksLen = links.length; d < linksLen; d++) {
            links[d].setAttributeNS(xlinkNamespace, 'href', '#' + newId);
          }

          elements[a].id = newId;
        };

        for (var a = 0, elementsLen = elements.length; a < elementsLen; a++) {
          _loop(a, elementsLen);
        }
      });
    } // Remove any unwanted/invalid namespaces that might have been added by SVG
    // editing tools.


    svg.removeAttribute('xmlns:a'); // Post page load injected SVGs don't automatically have their script
    // elements run, so we'll need to make that happen, if requested.
    // Find then prune the scripts.

    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;

    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      scriptType = scripts[i].getAttribute('type'); // Only process javascript types. SVG defaults to 'application/ecmascript'
      // for unset types.

      /* istanbul ignore else */

      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        // innerText for IE, textContent for other browsers.
        script = scripts[i].innerText || scripts[i].textContent; // Stash.

        /* istanbul ignore else */

        if (script) {
          scriptsToEval.push(script);
        } // Tidy up and remove the script element since we don't need it anymore.


        svg.removeChild(scripts[i]);
      }
    } // Run/Eval the scripts if needed.

    /* istanbul ignore else */


    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[imgUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        // :NOTE: Yup, this is a form of eval, but it is being used to eval code
        // the caller has explictely asked to be loaded, and the code is in a
        // caller defined SVG file... not raw user input.
        //
        // Also, the code is evaluated in a closure and not in the global scope.
        // If you need to put something in global scope, use 'window'.
        // tslint:disable-next-line:function-constructor
        new Function(scriptsToEval[l])(window);
      } // Remember we already ran scripts for this svg.


      ranScripts[imgUrl] = true;
    } // :WORKAROUND: IE doesn't evaluate <style> tags in SVGs that are
    // dynamically added to the page. This trick will trigger IE to read and use
    // any existing SVG <style> tags.
    //
    // Reference: https://github.com/iconic/SVGInjector/issues/23.


    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace);
    svg.setAttribute('xmlns:xlink', xlinkNamespace); // Replace the image with the svg.

    /* istanbul ignore else */

    if (el.parentNode) {
      el.parentNode.replaceChild(svg, el);
    } // Now that we no longer need it, drop references to the original element so
    // it can be GC'd.
    // TODO: Extract


    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  });
};

/* istanbul ignore file */
var EvalScripts;

(function (EvalScripts) {
  EvalScripts["Always"] = "always";
  EvalScripts["Once"] = "once";
  EvalScripts["Never"] = "never";
})(EvalScripts || (EvalScripts = {}));

var SVGInjector = function SVGInjector(elements, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$done = _ref.done,
      done = _ref$done === void 0 ? function () {
    return undefined;
  } : _ref$done,
      _ref$each = _ref.each,
      each = _ref$each === void 0 ? function () {
    return undefined;
  } : _ref$each,
      _ref$evalScripts = _ref.evalScripts,
      evalScripts = _ref$evalScripts === void 0 ? EvalScripts.Never : _ref$evalScripts,
      _ref$renumerateIRIEle = _ref.renumerateIRIElements,
      renumerateIRIElements = _ref$renumerateIRIEle === void 0 ? true : _ref$renumerateIRIEle;

  if (elements && 'length' in elements) {
    (function () {
      var elementsLoaded = 0;

      for (var i = 0, j = elements.length; i < j; i++) {
        injectElement(elements[i], function (error, svg) {
          each(error, svg);

          if (elements && 'length' in elements && elements.length === ++elementsLoaded) {
            done(elementsLoaded);
          }
        }, {
          evalScripts: evalScripts,
          renumerateIRIElements: renumerateIRIElements
        });
      }
    })();
  } else if (elements) {
    injectElement(elements, function (error, svg) {
      each(error, svg);
      done(1);
      elements = null;
    }, {
      evalScripts: evalScripts,
      renumerateIRIElements: renumerateIRIElements
    });
  } else {
    done(0);
  }
};

export default SVGInjector;
//# sourceMappingURL=svg-injector.js.map
